import type { PropsWithChildren, SelectHTMLAttributes } from 'react';

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
};

export function Select({ children, className = '', ...props }: PropsWithChildren<SelectProps>) {
    const color = 'bg-background text-foreground outline-muted';
    const caretPosition = 'border-r-8 border-r-transparent';

    return (
        <select className={`block w-full rounded-xs placeholder:opacity-50 mb-4 px-3 py-2 ${caretPosition} text-foreground leading-1 outline focus:ring-4 ring-primary/50 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none font-thin ${color} ${className}`} {...props}>
            {children}
        </select>
    );
}
